module.exports = new __parcel__URL__("nuage-pluie-1.23af1aaf.svg").toString();